import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { AuthInfoCardsComponent } from "../../components/auth-info-cards/auth-info-cards.component";
import { ButtonComponent, ButtonType, InputOtpComponent, SnackbarService, ThemeService } from "design-system";
import { AsyncPipe, NgOptimizedImage } from "@angular/common";
import { AuthenticationService } from "../../services/authentication.service";
import { from, map, Observable, tap } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";

@Component({
	selector: "app-mail-otp",
	imports: [
		AuthInfoCardsComponent,
		InputOtpComponent,
		ButtonComponent,
		NgOptimizedImage,
		AsyncPipe,
		ReactiveFormsModule,
	],
	templateUrl: "./mail-otp.component.html",
	styleUrl: "./mail-otp.component.scss",
})
export class MailOtpComponent implements OnInit {
	protected readonly ButtonType = ButtonType;
	protected currentUser$: Observable<{ [key: string]: any }> | undefined;
	private destroyedRef = inject(DestroyRef);
	protected otpForm = new FormGroup({
		otp: new FormControl("", [Validators.required]),
	});
	constructor(
		private authService: AuthenticationService,
		private themeService: ThemeService,
		private snackbarService: SnackbarService,
	) {
		this.themeService.setTheme("dark");
	}
	ngOnInit() {
		this.currentUser$ = from(this.authService.getCurrentSession()).pipe(
			takeUntilDestroyed(this.destroyedRef),
			map((session) => session?.getIdToken().payload as { [key: string]: any }),
			tap((user) => {
				console.log(user);
			}),
		);
	}

	verify(email: string) {
		const otp = this.otpForm.get("otp")?.value;
		console.log(otp);
		if (otp) {
			this.authService
				.confirmSignUp(email, otp)
				.then((res) => {
					this.snackbarService.openSnackbar({
						header: "Verification successful",
						type: "success",
						description: "You can now log in.",
					});
				})
				.catch((err) => {
					this.snackbarService.openSnackbar({
						header: "Verification failed",
						type: "error",
						description: "Please try again.",
					});
				});
		}
	}

	resendVerificationCode(email: string) {
		this.authService
			.sendVerificationCode(email)
			.then((res) => {
				this.snackbarService.openSnackbar({
					header: "Verification code sent",
					type: "success",
					description: "Please check your email for the verification code.",
				});
			})
			.catch((err) => {
				this.snackbarService.openSnackbar({
					header: "Something went wrong",
					type: "error",
					description: "Please refresh the page and try again.",
				});
			});
	}
}
